var map = {
	"./bank_BCM.svg": "66b8",
	"./bank_BOC.svg": "ab49",
	"./bank_CCB.svg": "ee92",
	"./bank_CMB.svg": "90e9",
	"./bank_PINGAN.svg": "a278",
	"./bank_SPD.svg": "13e6",
	"./code.svg": "d348",
	"./download.svg": "a334",
	"./edit.svg": "641e",
	"./eye-close.svg": "5e6a",
	"./eye.svg": "99fe",
	"./fly.svg": "e9da",
	"./fly_full.svg": "90e6",
	"./gauge_back.svg": "a2e6",
	"./go.svg": "2f45",
	"./guide_bank.svg": "39b9",
	"./home.svg": "67ef",
	"./home_full.svg": "a584",
	"./horn.svg": "03f3",
	"./horn_full.svg": "a904",
	"./i_add.svg": "e42c",
	"./i_area.svg": "d793",
	"./i_area_full.svg": "ce18",
	"./i_bell.svg": "1520",
	"./i_bell_full.svg": "ea60",
	"./i_browser.svg": "a176",
	"./i_browser_full.svg": "101c",
	"./i_call.svg": "4f49",
	"./i_call_full.svg": "d0d0",
	"./i_chart.svg": "69c6",
	"./i_chart_full.svg": "0e44",
	"./i_clook.svg": "839e",
	"./i_clook_full.svg": "9c66",
	"./i_close.svg": "1375",
	"./i_cp.svg": "8777",
	"./i_cp_full.svg": "0a3a",
	"./i_date.svg": "5c03",
	"./i_date_full.svg": "28bc",
	"./i_del.svg": "ad6f",
	"./i_down.svg": "3db5",
	"./i_left.svg": "5de5",
	"./i_load.svg": "77f6",
	"./i_location.svg": "b266",
	"./i_location_full.svg": "13c8",
	"./i_love.svg": "7717",
	"./i_love_full.svg": "7943",
	"./i_minus.svg": "4f5c",
	"./i_msg.svg": "ff89",
	"./i_msg_full.svg": "263c",
	"./i_note.svg": "73cd",
	"./i_note_full.svg": "9ec0",
	"./i_page.svg": "8a4f",
	"./i_page_full.svg": "3c10",
	"./i_pay.svg": "dec7",
	"./i_pay_full.svg": "6393",
	"./i_right.svg": "d5d4",
	"./i_search.svg": "4c94",
	"./i_setting.svg": "d3c9",
	"./i_setting_full.svg": "b54f",
	"./i_success.svg": "97fd",
	"./i_table.svg": "5f46",
	"./i_table_full.svg": "16f2",
	"./i_up.svg": "2825",
	"./i_upload.svg": "1ef5",
	"./i_usr.svg": "0c74",
	"./i_usr_full.svg": "1d11",
	"./i_warnning.svg": "d95d",
	"./ii_user.svg": "dafd",
	"./index_more_five.svg": "3b8e",
	"./index_more_four.svg": "76bb",
	"./index_more_one.svg": "3472",
	"./index_more_six.svg": "dee9",
	"./index_more_three.svg": "a5d8",
	"./index_more_two.svg": "b319",
	"./index_question.svg": "7b549",
	"./lock.svg": "48cc",
	"./logo.svg": "d2bc",
	"./logo1.svg": "d3d0",
	"./mail.svg": "9e4b",
	"./money.svg": "9cec",
	"./portal_logo.svg": "6dc6",
	"./pwd.svg": "69b4",
	"./up.svg": "dad7",
	"./中国银行-01.svg": "d3b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eed2";